import { createElement, lazy } from "react";
import { app, fullscreen } from "~/helpers/routes";
import { paths } from "~/router/paths";
import { LegacyStoreLibraryInsightsRedirect } from "~/router/routes/LegacyStoreLibraryInsightsRedirect";
import { LegacyCompetitorResearchDetailsRedirect } from "~/router/routes/LegacyCompetitorResearchRedirect";

const Dashboard = lazy(() => import("~/pages/dashboard"));
const ThemeDetectorPage = lazy(() => import("~/pages/theme-detector"));

const ProductDatabase = lazy(() => import("~/pages/product-database"));
const ProductDatabaseDetails = lazy(
  () => import("~/pages/product-database/ProductDetails")
);

const MyTrackingStores = lazy(() => import("~/pages/my-trackings/TrackStores"));
const MyTrackingProducts = lazy(() => import("~/pages/my-trackings/Products"));
const StoreDetailPage = lazy(() => import("~/pages/top-stores/StoreInsights"));
const ProductDetailPage = lazy(() => import("~/pages/product-detail"));
const TopProductsPage = lazy(() => import("~/pages/top-products"));
const TopStoresPage = lazy(() => import("~/pages/top-stores"));
const StoreInsightsPage = lazy(
  () => import("~/pages/top-stores/StoreInsights")
);
const CancelationPage = lazy(() => import("~/pages/cancel"));

const CompetitorAnalysisPage = lazy(
  () => import("~/pages/competitor-analysis")
);
const AliExpressProductsPage = lazy(
  () => import("~/pages/aliexpress-products")
);

export const routes: Array<any> = [
  {
    path: "/sales-tracker/top-stores/insights/:storeId",
    element: createElement(LegacyStoreLibraryInsightsRedirect),
  },
  {
    path: paths.app.legacyCompetitorResearchDetails,
    element: createElement(LegacyCompetitorResearchDetailsRedirect),
  },
  {
    path: paths.app.home,
    element: app(Dashboard),
  },
  {
    path: paths.app.themeDetector,
    element: app(ThemeDetectorPage),
  },
  {
    path: paths.app.aliexpressProducts,
    element: app(AliExpressProductsPage),
  },
  {
    path: paths.app.myTrackingStores,
    element: app(MyTrackingStores),
  },
  {
    path: paths.app.myTrackingStores,
    element: app(MyTrackingStores),
  },
  {
    path: paths.app.myTrackingProducts,
    element: app(MyTrackingProducts),
  },
  {
    // new route for a specific store
    path: paths.app.myTrackingStoreDetail,
    element: app(StoreDetailPage),
  },
  {
    path: paths.app.myTrackingProductDetail,
    element: app(ProductDetailPage),
  },
  {
    path: paths.app.topProducts,
    element: app(TopProductsPage),
  },
  {
    path: paths.app.storeLibrary,
    element: app(TopStoresPage),
  },
  {
    path: paths.app.storeInsights,
    element: app(StoreInsightsPage),
  },
  {
    path: paths.app.productLibrary,
    element: app(ProductDatabase),
  },
  {
    path: paths.app.productLibraryDetails,
    element: app(ProductDatabaseDetails),
  },
  {
    path: paths.app.competitorAnalysis,
    element: app(CompetitorAnalysisPage),
  },
  {
    path: paths.app.cancel,
    element: fullscreen(CancelationPage),
  },
];
